import React from 'react';
function ThumbsDown({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.935 4h2.17c.461-.008.908.15 1.257.446.35.295.576.706.638 1.154v5.6a1.84 1.84 0 01-.638 1.155c-.349.295-.796.453-1.256.445h-2.17m-5.69 1.6v3.2c0 .637.256 1.247.713 1.697.458.45 1.078.703 1.725.703l3.252-7.2V4h-9.17a1.642 1.642 0 00-1.071.381c-.3.25-.496.598-.555.98l-1.122 7.2a1.575 1.575 0 00.381 1.29 1.648 1.648 0 001.245.55h4.601z"
      />
    </svg>
  );
}

export default ThumbsDown;
